import type { ModalResult } from '@/modules/miiaFw/types/components/commonModal'
import { useCommonModalStore } from '@/stores/commonModalStore'

/**
 * zipダウンロード確認コンファーム表示
 * @returns モーダル結果
 */
export const confirmDownloadZipFile = async (): Promise<ModalResult> => {
  const commonModalStore = useCommonModalStore()
  return await commonModalStore.openConfirmModal({
    title: 'zipダウンロード',
    body: '未アップロードのデータをダウンロードしますか？<br>ダウンロードには最大2～3分ほど時間がかかります。',
    okTitle: 'ダウンロード',
    okColor: 'success',
    cancelTitle: 'いいえ'
  })
}

/**
 * 未アップロードデータなしアラート表示
 * @returns モーダル結果
 */
export const alertNotUploadedData = async (): Promise<ModalResult> => {
  const commonModalStore = useCommonModalStore()
  return await commonModalStore.openAlertModal({
    title: 'zipダウンロード',
    body: '未アップロードのデータはありません。',
    okTitle: '閉じる'
  })
}

/**
 * zipファイルをアップロードするモーダルを表示し、FileListを返す
 * @returns ファイルが選択された場合はFileListを、ファイルが選択されないもしくは「キャンセル」を押下されればfalseを返す
 */
export const confirmSelectZipFile = async (): Promise<false | FileList> => {
  const commonModalStore = useCommonModalStore()
  const confirmed = await commonModalStore.openConfirmModal({
    title: 'zipアップロード',
    body: 'アップロードしたいzipファイルを選択してください。<br>アップロードには1ファイルにつき最大2～3分ほど時間がかかります。',
    okTitle: 'zipファイルを選択',
    cancelTitle: 'キャンセル'
  })
  if (!confirmed) {
    return false
  }

  return new Promise<FileList | false>(resolve => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.zip'
    input.multiple = true
    input.onchange = event => {
      const target = event.target as HTMLInputElement
      if (!target || !target.files || target.files.length === 0) {
        resolve(false)
        return
      }
      resolve(target.files)
    }
    input.click()
  })
}

/**
 * 不正zipファイルアラート表示
 * @returns モーダル結果
 */
export const alertInvalidZipFile = async (): Promise<ModalResult> => {
  const commonModalStore = useCommonModalStore()
  return await commonModalStore.openAlertModal({
    title: 'zipアップロード',
    body: '調査システムで作成されたデータではないzipファイルが含まれています。',
    okTitle: '閉じる'
  })
}

/**
 * zipアップロード完了通知表示
 * @returns モーダル結果
 */
export const notifyCompletedUpload = async (): Promise<ModalResult> => {
  const commonModalStore = useCommonModalStore()
  return await commonModalStore.openConfirmModal({
    title: 'zipアップロード',
    body: 'アップロードが完了しました。',
    okTitle: '閉じる'
  })
}

/**
 * アップロード失敗データダウンロード確認コンファーム表示
 * @returns モーダル結果
 */
export const confirmDownloadErrorZipFile = async (): Promise<ModalResult> => {
  const commonModalStore = useCommonModalStore()
  return await commonModalStore.openConfirmModal({
    title: 'zipアップロード',
    body: 'アップロードを実行しましたが、アップロードに失敗したデータが存在します。失敗したデータをダウンロードしますか？',
    okTitle: 'ダウンロード',
    okColor: 'success',
    cancelTitle: 'いいえ'
  })
}

/**
 * zipアップロード完了通知表示
 * @param fileName ファイル名
 * @returns モーダル結果
 */
export const notigyCompletedErrorFileDownload = async (fileName: string): Promise<ModalResult> => {
  const commonModalStore = useCommonModalStore()
  return await commonModalStore.openConfirmModal({
    title: 'zipアップロード',
    body: `アップロードに失敗したデータをダウンロードしました。<br>ダウンロードしたzipファイルは「${fileName}.zip」です。`,
    okTitle: '閉じる'
  })
}
